import React from 'react'
import styled, { css } from 'styled-components'
import { showLoginErrorMessages } from '@utilities/mdHandler'

const MDBanner = ({ message, onClose, ...bannerType }) => {
  const { error } = bannerType
  return (
    <Banner {...bannerType}>
      <span>{error ? showLoginErrorMessages(message) : message}</span>
      <span className="fas fa-times" onClick={onClose} />
    </Banner>
  )
}

export default MDBanner

const Banner = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  color: black;
  background-color: lightgray;
  border-color: black;
  border-radius: 4px;
  padding: 10px 5px;
  span:nth-child(2) {
    position: absolute;
    right: 12px;
    cursor: pointer;
  }
  ${(props) =>
    props.success &&
    css`
      background: lightgreen;
      border-color: green;
      color: green;
    `};
  ${(props) =>
    props.error &&
    css`
      background-color: #f8d7da;
      border-color: #f5c6cb;
      color: #721c24;
    `};
`
